<div class="row userProfile" *ngIf="userDetails?.isActivate" [ngClass]="isArabic ? 'arabicAlign rightAlign' : ''">
    <div class="col-6">
        <label class="ques">
            <span *ngIf="!isArabic">First Name :</span>
            <span *ngIf="isArabic">: الأسم الاول</span>
        </label>
        <div class="ans-pnl user-ans-pnl">
            <label class="">{{userDetails.firstname}}</label>
        </div>
    </div>
    <div class="col-6">
        <label class="ques">
            <span *ngIf="!isArabic">Last Name :</span>
            <span *ngIf="isArabic">: أسم العائلة</span>
        </label>
        <div class="ans-pnl user-ans-pnl">
        <label class="">{{userDetails.lastname}}</label>
        </div>
    </div>
    <div class="col-6 pt-4">
        <label class="ques">
            <span *ngIf="!isArabic">Contact No. :</span>
            <span *ngIf="isArabic">: رقم التواصل</span>
        </label>
        <div class="ans-pnl user-ans-pnl">
            <label class="">
                <span *ngIf="userDetails?.countrycode">+</span>
                <span>{{userDetails.countrycode}}</span>&nbsp;
                <span>{{userDetails.mobilephone}}</span>
            </label>
        </div>
    </div>
    <div class="col-6 pt-4">
        <label class="ques">
            <span *ngIf="!isArabic">Email Id :</span>
            <span *ngIf="isArabic">: البريد الإلكتروني</span>
        </label>
        <div class="ans-pnl user-ans-pnl">
            <label class="">{{userDetails.email}}</label>
        </div>
    </div>
    <div class="col-6 pt-4">
        <label class="ques">
            <span *ngIf="!isArabic">Emirates ID :</span>
            <span *ngIf="isArabic">: رقم الهوية الإماراتية</span>
        </label>
        <div class="ans-pnl user-ans-pnl">
            <label class="">{{userDetails.emiratesId}}</label>
        </div>
    </div>
    <div class="col-6 pt-4">
        <label class="ques">
            <span *ngIf="!isArabic">Assssment Entity Name :</span>
            <span *ngIf="isArabic">: أسم الشركة</span>
        </label>
        <div class="ans-pnl user-ans-pnl">
        <label class="">{{userDetails.assessmentUnit.name}}</label>
        </div>
    </div>
  </div>
